//
// Fill stars based on the data value
//
function starReviews() {
	var starReviews = document.querySelectorAll('.stars');

	var observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			var delay = 0; // Reset delay for each review
			if (entry.isIntersecting) {

				var starReview = entry.target;
				var dataStars = starReview.getAttribute('data-stars');
				var stars = starReview.querySelectorAll('svg');

				stars.forEach((svg, i) => {
				setTimeout(() => {
					if (i < dataStars) {
					svg.classList.add('fill');
					}
				}, delay * 1000); // Delay in milliseconds

				delay += 0.2; // Increase the delay for each star
				});

				observer.unobserve(starReview);

			}
		});
	});

	starReviews.forEach((starReview) => {
		observer.observe(starReview);
	});
}
window.addEventListener('DOMContentLoaded', starReviews);
window.addEventListener('facetwp-loaded', starReviews);
window.addEventListener('facetwp-refresh', starReviews);
//
// Rotate shapes on scroll
//
function scrollRotate() {
    let shapes = document.querySelectorAll(".site-main .shapes svg");
    for (var i = 0; i < shapes.length; i++) {
        shapes[i].style.opacity = "1";
        shapes[i].style.transform = "rotate(" + window.pageYOffset / 25 + "deg)";
    }
}

window.addEventListener("scroll", scrollRotate);

//
// Accordion
//
function accordion() {
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach(accordion => {
        const lists = accordion.querySelectorAll('li');

        lists.forEach(list => {
            const anchor = list.querySelector('a');

            if (anchor) {
                anchor.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    // console.log(e);

                    // Get the question and answer elements within the list item
                    const text = list.querySelector('.answer');
                    const height = text.scrollHeight;

                    // Get the current state of the clicked list item
                    const currentState = list.getAttribute('aria-expanded') === 'true';

                    // Close all other lists
                    lists.forEach(otherList => {
                        if (otherList !== list) {
                            const otherText = otherList.querySelector('.answer');
                            if (otherText) {
                                otherText.style.maxHeight = '0px';
                            }
                            otherList.classList.remove('active');
                            otherList.setAttribute('aria-expanded', 'false');
                        }
                    });

                    console.log(currentState);

                    // Toggle the current list
                    if (currentState) {
                        // If currently open, close it
                        text.style.maxHeight = '0px';
                        list.classList.remove('active');
                        setTimeout(() => {
                            list.setAttribute('aria-expanded', 'false');
                        }, 300);
                    } else {
                        // If currently closed, open it
                        text.style.maxHeight = height + 'px';
                        list.classList.add('active');
                        setTimeout(() => {
                            list.setAttribute('aria-expanded', 'true');
                        }, 300);
                    }
                });
            }
        });
    });
}
accordion();
// window.addEventListener('DOMContentLoaded', accordion);
